import { fetchFromIndexedDB, removeFromIndexedDB } from "../utils/indexedDb"

export const retryOfflineMutations = async (client: any, updateProgressState: (currentIndex: number) => void) => {
    const pendingMutations = await fetchFromIndexedDB()
    let currentIndex = 0

    for (const { mutation, variables } of pendingMutations) {
        try {
            await client.mutate({ mutation, variables })
            await removeFromIndexedDB(mutation.definitions[0].name.value)
            // Update progress after successful mutation
            updateProgressState(++currentIndex)
        } catch (error) {
            console.error("Failed to retry mutation:", error)
            return false
        }
    }
    return true
}
